import contentGroupIcon from "Static/svg/icon-content-group.svg";
import folderIcon from "Static/svg/icon-folder.svg";
import webPageIcon from "Static/svg/icon-webpage.svg";
import {
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
} from "fleet/constant/media-library";
import { PropTypeMediaEntryTypes } from "fleet/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { Badge } from "react-bootstrap";

class SpotPreview extends React.PureComponent {
  static get propTypes() {
    return {
      showControls: PropTypes.bool,
      mimeType: PropTypes.string,
      numberOfSpots: PropTypes.number,
      type: PropTypeMediaEntryTypes,
      url: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      showControls: true,
      mimeType: "",
      numberOfSpots: 0,
      type: "",
      url: "",
    };
  }

  _renderContentGroupPreview(numberOfSpots) {
    return (
      <div className="spot-preview-badge-container">
        <Badge className="spot-preview-badge">{numberOfSpots}</Badge>
        {this._renderIconPreview(contentGroupIcon)}
      </div>
    );
  }

  _renderIconPreview(url) {
    return this._renderImagePreview(url, "spot-preview-icon");
  }

  _renderImagePreview(url, className = "") {
    return <img className={`spot-preview ${className}`} src={url} />;
  }

  _renderContentPreview(props) {
    const { showControls, mimeType, url } = props;

    if (!mimeType || !url) {
      return <div>No Preview</div>;
    }

    if (mimeType === MEDIA_ENTRY_WEBPAGE) {
      return this._renderIconPreview(webPageIcon);
    }

    if (mimeType.startsWith("image")) {
      return this._renderImagePreview(url);
    }

    if (mimeType.startsWith("video")) {
      // Force video element to rerender.
      // https://stackoverflow.com/a/47382850/1870013
      return (
        <video
          key={url}
          preload={"false"}
          className="spot-preview"
          controls={showControls}
        >
          <source src={url} />
        </video>
      );
    }

    return null;
  }

  render() {
    const { numberOfSpots, type, url } = this.props;

    switch (type) {
      case MEDIA_ENTRY_CONTENT_GROUP:
        return this._renderContentGroupPreview(numberOfSpots);
      case MEDIA_ENTRY_APPLICATION:
        return this._renderImagePreview(url);
      case MEDIA_ENTRY_FOLDER:
        return this._renderIconPreview(folderIcon);
      case MEDIA_ENTRY_USER_CONTENT:
        return this._renderContentPreview(this.props);
      case MEDIA_ENTRY_WEBPAGE:
        return this._renderIconPreview(webPageIcon);
      default:
        return <div>No Preview</div>;
    }
  }
}

export { SpotPreview };
